module.exports = __webpack_public_path__ + "Roboto-Light.054fa50baa6598a7bf0c.svg";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-Light.svg
// module id = 81
// module chunks = 17